module.exports = __webpack_public_path__ + "media/images/sales/nanairoweek/heading-mv-f5f8eea6e75f88a53ed93509105eacd7.png";